import React, { useState, useEffect } from 'react';
import './App.css';

function getCurrentRoute() {
  const hashRoute = (window.location.hash || '').replace(/^#/, '');
  return hashRoute || window.location.pathname;
}

function PrivacyPolicyPage() {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <div className="container privacy-header-inner">
          <img src="/images/logo.png" alt="Worldexinc Logo" className="privacy-logo" />
          <a href="/" className="privacy-back-link">Back to Home</a>
        </div>
      </header>

      <main className="privacy-main">
        <div className="container privacy-content">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Effective date: March 17, 2026</p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>
              We collect information you provide directly, such as your name, email address, phone number,
              company details, and any message content sent through our website, email, or phone.
            </p>
          </section>

          <section>
            <h2>2. How We Use Information</h2>
            <p>
              We use collected information to respond to inquiries, provide product information and quotations,
              improve our services, and maintain business communication with customers and partners.
            </p>
          </section>

          <section>
            <h2>3. Cookies and Analytics</h2>
            <p>
              Our website may use cookies and similar technologies for functionality and analytics. You can
              manage cookie preferences through your browser settings.
            </p>
          </section>

          <section>
            <h2>4. Data Sharing</h2>
            <p>
              We do not sell personal information. We may share information with service providers that support
              website hosting, communication, or operations, and where required by law.
            </p>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>
              We use reasonable administrative and technical safeguards to protect personal information. No
              method of online transmission or storage is completely secure.
            </p>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <p>
              Depending on your location, you may have rights to request access, correction, or deletion of
              personal data. To make a request, contact us using the details below.
            </p>
          </section>

          <section>
            <h2>7. Contact</h2>
            <p>
              Worldexinc<br />
              Email: info@worldexinc.ca<br />
              Phone: +1 (438) 990-5985, +1 (514) 804-0797<br />
              Address: 1220 rue Bergar H7L 5A2, Laval, Quebec, Canada
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}

function RefrigerationEquipmentPage() {
  const products = [
    {
      image: '/images/Condensing/CondensingUnit.jpeg',
      title: 'Condensing Unit',
      category: 'Condensing Unit',
      description: 'High-efficiency condensing unit designed for commercial and industrial cold storage facilities. Features quiet operation, robust construction, and energy-saving performance suitable for a wide range of ambient temperatures.',
      specs: ['Capacity: 1/2 HP – 1/3 HP – 1/5 HP – 0.75 HP – 1 HP', 'Refrigerant: R134a', 'Temperature Range: -20°C to +20°C']
    },
    {
      image: '/images/Condensing/CondensingBuyuk.jpeg',
      title: 'Condensing Unit (Type 2)',
      category: 'Condensing Unit',
      description: 'Compact and space-efficient condensing unit ideal for medium-scale cold room applications. Built for reliability in demanding environments with easy maintenance access and simplified installation.',
      specs: ['Capacity: 1.5 HP – 2 HP – 2.5 HP – 3 HP', 'Refrigerant: R404a', 'Temperature Range: -20°C to +20°C']
    },
    {
      image: '/images/Condensing/ColdroomEvaporator Coil 2hp-3hp.jpeg',
      title: 'Coldroom Evaporator Coil 2HP – 3HP',
      category: 'Evaporator',
      description: 'Heavy-duty evaporator coil engineered for medium to large cold room installations. Provides superior air distribution and efficient heat exchange for consistent temperature control in demanding storage environments.',
      specs: ['Capacity: 2 HP – 3 HP', 'Coil Type: Fin & Tube', 'Defrost: Electric / Air Defrost']
    },
    {
      image: '/images/Condensing/ColdroomEvaporator Coil 1:2hp-1:3hp-1:5.jpeg',
      title: 'Coldroom Evaporator Coil ½HP – ⅓HP – ⅕HP',
      category: 'Evaporator',
      description: 'Low-capacity evaporator coil designed for small cold rooms and refrigerated display cases. Compact unit with efficient airflow for maintaining precise temperature in smaller storage areas.',
      specs: ['Capacity: 1/5 HP – 1/3 HP – 1/2 HP', 'Coil Type: Fin & Tube', 'Application: Small Cold Rooms']
    },
    {
      image: '/images/Condensing/Compressor1.jpeg',
      title: 'Compressor (Type 1)',
      category: 'Compressor',
      description: 'Industrial-grade hermetic compressor delivering consistent and reliable performance for commercial refrigeration systems. Designed for long-term operation with low vibration and high energy efficiency.',
      specs: ['Capacity: 1/5 HP – 1/3 HP – 1/2 HP', 'Refrigerant: R134a']
    },
    {
      image: '/images/Condensing/CompressorType2.jpeg',
      title: 'Compressor (Type 2)',
      category: 'Compressor',
      description: 'Heavy-duty compressor built for demanding commercial and industrial refrigeration applications. Features advanced motor protection, optimized displacement, and compatibility with modern eco-friendly refrigerants.',
      specs: ['Capacity: 1.5 HP – 2 HP – 2.5 HP – 3 HP', 'Refrigerant: R404a']
    }
  ];

  return (
    <div className="refrig-page">
      <header className="privacy-header">
        <div className="container privacy-header-inner">
          <img src="/images/logo.png" alt="Worldexinc Logo" className="privacy-logo" />
          <a href="/" className="privacy-back-link">Back to Home</a>
        </div>
      </header>

      <main className="refrig-main">
        <div className="container">
          <div className="refrig-page-header">
            <span className="section-label">Refrigeration Equipment</span>
            <h1>Cold Storage & Refrigeration Solutions</h1>
            <p>Complete refrigeration system components for commercial and industrial cold storage applications. All units are sourced from certified manufacturers and rigorously tested for reliability.</p>
          </div>

          <div className="refrig-products-grid">
            {products.map((product, index) => (
              <div key={index} className="refrig-product-card">
                <div className="refrig-product-image">
                  <img src={product.image} alt={product.title} />
                  <span className="refrig-category-badge">{product.category}</span>
                </div>
                <div className="refrig-product-info">
                  <h3>{product.title}</h3>
                  <p>{product.description}</p>
                  <ul className="refrig-specs">
                    {product.specs.map((spec, i) => (
                      <li key={i}><span>✓</span> {spec}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="refrig-cta">
            <h3>Request a Quote</h3>
            <p>Contact us for pricing, availability, and custom configurations.</p>
            <div className="refrig-cta-links">
              <a href="mailto:info@worldexinc.ca" className="contact-pill">Email: info@worldexinc.ca</a>
              <a href="tel:+14389905985" className="contact-pill">Call: +1 (438) 990-5985</a>
            </div>
          </div>
        </div>
      </main>

      <footer className="refrig-footer">
        <div className="container">
          <p>&copy; 2026 Worldexinc. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [currentRoute, setCurrentRoute] = useState(getCurrentRoute);

  // Stats data
  const stats = [
    { number: '15+', label: 'Years Experience' },
    { number: '500+', label: 'Projects' },
    { number: '50+', label: 'Countries' },
    { number: '99%', label: 'Satisfaction' }
  ];

  // Features data
  const features = [
    { icon: '01', title: 'Premium Quality', desc: 'ISO 9001:2015 certified manufacturing with strict quality control' },
    { icon: '02', title: 'Fast Delivery', desc: 'Efficient logistics network ensuring timely delivery worldwide' },
    { icon: '03', title: 'Competitive Pricing', desc: 'Best value for money with bulk order discounts' },
    { icon: '04', title: 'Technical Support', desc: '24/7 expert assistance and installation guidance' },
    { icon: '05', title: 'Warranty', desc: 'Comprehensive warranty coverage on all products' },
    { icon: '06', title: 'Global Reach', desc: 'Serving clients in over 50 countries worldwide' }
  ];

  // Images
  const rImages = ['r1.jpeg', 'r2.jpeg', 'image052.jpeg', 'r4.jpeg'].map(img => `/images/${img}`);
  const regularImages = Array.from({ length: 68 }, (_, i) => `/images/image${String(i + 1).padStart(3, '0')}.jpeg`)
    .filter((img) => img !== '/images/image003.jpeg');
  const images = [...rImages, ...regularImages];

  // Documents (PDFs)
  const documents = [
    { name: 'Certificate 230506006SHF-001', file: '/images/230506006SHF-001.pdf', description: 'Certification document' },
    { name: 'B2 Fire Proof Test Report', file: '/images/B2%20fire%20proof%20test%20report.pdf', description: 'Fire resistance test results' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentRoute(getCurrentRoute());
    };

    window.addEventListener('hashchange', handleRouteChange);
    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('hashchange', handleRouteChange);
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const isPrivacyPage =
    currentRoute === '/privacy-policy' ||
    currentRoute === '/privacy-policy/';

  const isRefrigerationPage =
    currentRoute === '/refrigeration' ||
    currentRoute === '/refrigeration/';

  if (isPrivacyPage) {
    return <PrivacyPolicyPage />;
  }

  if (isRefrigerationPage) {
    return <RefrigerationEquipmentPage />;
  }

  return (
    <div className="App">
      {/* Header */}
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="logo">
            <img src="/images/logo.png" alt="Worldexinc Logo" className="logo-img" />
          </div>
          <button 
            className="menu-toggle" 
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className={menuOpen ? 'active' : ''}>
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#products">Products</a>
            <a href="/#/refrigeration">Refrigeration</a>
            <a href="#gallery">Gallery</a>
            <a href="#documents">Documents</a>
            <a href="#contact">Contact</a>
            <a href="/#/privacy-policy">Privacy Policy</a>
          </nav>
        </div>
      </header>

      {/* Contact Strip */}
      <section className="contact-strip">
        <div className="container">
          <div className="contact-strip-text">Contact us:</div>
          <div className="contact-strip-links">
            <a href="mailto:info@worldexinc.ca" className="contact-strip-link">info@worldexinc.ca</a>
            <span className="contact-strip-sep">|</span>
            <a href="tel:+14389905985" className="contact-strip-link">+1 (438) 990-5985</a>
            <span className="contact-strip-sep">|</span>
            <a href="tel:+15148040797" className="contact-strip-link">+1 (514) 804-0797</a>
            <span className="contact-strip-sep">|</span>
            <a href="https://www.instagram.com/worldexinc.ca" target="_blank" rel="noopener noreferrer" className="contact-strip-link contact-strip-social" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61581325739211" target="_blank" rel="noopener noreferrer" className="contact-strip-link contact-strip-social" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">Leading Sandwich Panel Manufacturer</div>
            <h1 className="hero-title">Premium Sandwich Panels for Industrial Excellence</h1>
            <p className="hero-description">
              Worldexinc delivers high-performance sandwich panels with superior insulation, 
              durability, and fire resistance. Trusted by industry leaders worldwide for over 15 years.
            </p>
            <div className="hero-trust">
              <span>✓ 500+ Projects Delivered</span>
            </div>
          </div>
          <div className="hero-image">
            <img src={images[0]} alt="Sandwich Panel Manufacturing" />
            <div className="hero-stats">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Why Choose Us</span>
            <h2>Your Trusted Partner in Construction Solutions</h2>
            <p>We combine cutting-edge technology with decades of expertise to deliver exceptional results</p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-new">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img src={images[1]} alt="Manufacturing Facility" />
              <div className="about-badge">
                <div className="badge-number">15+</div>
                <div className="badge-text">Years of Excellence</div>
              </div>
            </div>
            <div className="about-content">
              <span className="section-label">About Worldexinc</span>
              <h2>Leading Manufacturer of High-Quality Sandwich Panels</h2>
              <p>
                With over 15 years of industry experience, Worldexinc has established itself as a premier 
                manufacturer and supplier of sandwich panels. Our state-of-the-art production facilities 
                and commitment to quality have made us the preferred choice for industrial, commercial, 
                and residential projects worldwide.
              </p>
              <p>
                We utilize advanced manufacturing techniques and premium materials to ensure every panel 
                meets the highest international standards. Our products are designed to provide superior 
                thermal insulation, fire resistance, and structural integrity.
              </p>
              <div className="about-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">1</div>
                  <div>
                    <strong>Advanced Technology</strong>
                    <p>State-of-the-art production lines with automated quality control</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">2</div>
                  <div>
                    <strong>Expert Team</strong>
                    <p>Experienced engineers and technical specialists at your service</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">3</div>
                  <div>
                    <strong>Quality Assurance</strong>
                    <p>ISO 9001 certified manufacturing processes and materials</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="products">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Our Products</span>
            <h2>Premium Sandwich Panel Solutions</h2>
            <p>Engineered for superior performance in demanding environments</p>
          </div>

          <div className="product-main">
            <div className="product-images">
              <div className="product-image-main">
                <img src={images[0]} alt="Sandwich Panel" />
              </div>
              <div className="product-image-grid">
                <img src={images[1]} alt="Panel Detail" />
                <img src={images[2]} alt="Installation" />
                <img src={images[3]} alt="Application" />
              </div>
            </div>
            <div className="product-info">
              <h3>High-Performance Sandwich Panels</h3>
              <div className="product-rating">
                <span className="stars">★★★★★</span>
                <span className="rating-text">4.9/5.0 (500+ Reviews)</span>
              </div>
              <p className="product-description">
                Our premium sandwich panels combine advanced insulation technology with exceptional 
                structural strength. Ideal for industrial, commercial, and cold storage applications 
                where performance and reliability are critical.
              </p>
              
              <div className="product-features">
                <h4>Key Features</h4>
                <div className="features-list">
                  <div className="feature-item-small">
                    <span className="check">✓</span>
                    <div>
                      <strong>Superior Insulation</strong>
                      <p>U-value as low as 0.18 W/m²K</p>
                    </div>
                  </div>
                  <div className="feature-item-small">
                    <span className="check">✓</span>
                    <div>
                      <strong>Fire Resistance</strong>
                      <p>A1/A2 class fire rating</p>
                    </div>
                  </div>
                  <div className="feature-item-small">
                    <span className="check">✓</span>
                    <div>
                      <strong>Lightweight Design</strong>
                      <p>Easy handling and installation</p>
                    </div>
                  </div>
                  <div className="feature-item-small">
                    <span className="check">✓</span>
                    <div>
                      <strong>Weather Resistant</strong>
                      <p>UV protection and corrosion resistant</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-specs-table">
                <h4>Technical Specifications</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>Panel Thickness</td>
                      <td><strong>50mm, 75mm, 100mm, 120mm, 150mm, 200mm</strong></td>
                    </tr>
                    <tr>
                      <td>Core Material</td>
                      <td><strong>PIR, PUR, EPS, Mineral Wool</strong></td>
                    </tr>
                    <tr>
                      <td>Thermal Conductivity</td>
                      <td><strong>0.18 - 0.23 W/m²K</strong></td>
                    </tr>
                    <tr>
                      <td>Fire Classification</td>
                      <td><strong>A1, A2-s1, d0, B-s1, d0</strong></td>
                    </tr>
                    <tr>
                      <td>Standard Width</td>
                      <td><strong>960mm, 1000mm, 1150mm</strong></td>
                    </tr>
                    <tr>
                      <td>Coating Material</td>
                      <td><strong>PPGI, Stainless Steel, Aluminum</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

          <div className="applications">
            <h3>Industry Applications</h3>
            <div className="application-grid">
              <div className="application-card">
                <div className="app-icon">01</div>
                <h4>Industrial Buildings</h4>
                <p>Factories, warehouses, and manufacturing facilities</p>
              </div>
              <div className="application-card">
                <div className="app-icon">02</div>
                <h4>Commercial Projects</h4>
                <p>Shopping malls, offices, and retail spaces</p>
              </div>
              <div className="application-card">
                <div className="app-icon">03</div>
                <h4>Cold Storage</h4>
                <p>Refrigerated warehouses and food processing</p>
              </div>
              <div className="application-card">
                <div className="app-icon">04</div>
                <h4>Modular Buildings</h4>
                <p>Portable and temporary structures</p>
              </div>
              <div className="application-card">
                <div className="app-icon">05</div>
                <h4>Agricultural</h4>
                <p>Livestock buildings and storage facilities</p>
              </div>
              <div className="application-card">
                <div className="app-icon">06</div>
                <h4>Sports Facilities</h4>
                <p>Gyms, arenas, and recreational centers</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Refrigeration Equipment Section */}
      <section id="refrigeration" className="refrig-section">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Refrigeration Equipment</span>
            <h2>Cold Storage & Refrigeration Solutions</h2>
            <p>Complete refrigeration components including condensing units, evaporator coils, and compressors for any scale</p>
          </div>

          <div className="refrig-preview-grid">
            <a href="/#/refrigeration" className="refrig-preview-card">
              <div className="refrig-preview-image">
                <img src="/images/Condensing/CondensingUnit.jpeg" alt="Condensing Unit" />
              </div>
              <div className="refrig-preview-info">
                <span className="refrig-preview-tag">Condensing Unit</span>
                <h3>High-Efficiency Condensing Units</h3>
                <p>Commercial and industrial condensing units for reliable cold storage operation at any scale.</p>
              </div>
            </a>
            <a href="/#/refrigeration" className="refrig-preview-card">
              <div className="refrig-preview-image">
                <img src="/images/Condensing/ColdroomEvaporator Coil 2hp-3hp.jpeg" alt="Coldroom Evaporator Coil" />
              </div>
              <div className="refrig-preview-info">
                <span className="refrig-preview-tag">Evaporator</span>
                <h3>Coldroom Evaporator Coils</h3>
                <p>Fin & tube evaporator coils for small to large cold rooms. Available in multiple capacity ranges.</p>
              </div>
            </a>
            <a href="/#/refrigeration" className="refrig-preview-card">
              <div className="refrig-preview-image">
                <img src="/images/Condensing/Compressor1.jpeg" alt="Compressor" />
              </div>
              <div className="refrig-preview-info">
                <span className="refrig-preview-tag">Compressor</span>
                <h3>Industrial Compressors</h3>
                <p>Hermetic and semi-hermetic compressors engineered for demanding commercial refrigeration systems.</p>
              </div>
            </a>
          </div>

          <div className="refrig-section-cta">
            <a href="/#/refrigeration" className="btn-primary">View All Refrigeration Equipment →</a>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Project Gallery</span>
            <h2>Completed Projects & Installations</h2>
            <p>Explore our portfolio of successful projects delivered worldwide</p>
          </div>

          <div className="gallery-filters">
            <button 
              className={activeTab === 'all' ? 'filter-btn active' : 'filter-btn'}
              onClick={() => setActiveTab('all')}
            >
              All Projects
            </button>
            <button 
              className={activeTab === 'industrial' ? 'filter-btn active' : 'filter-btn'}
              onClick={() => setActiveTab('industrial')}
            >
              Industrial
            </button>
            <button 
              className={activeTab === 'commercial' ? 'filter-btn active' : 'filter-btn'}
              onClick={() => setActiveTab('commercial')}
            >
              Commercial
            </button>
            <button 
              className={activeTab === 'storage' ? 'filter-btn active' : 'filter-btn'}
              onClick={() => setActiveTab('storage')}
            >
              Cold Storage
            </button>
          </div>

          <div className="gallery-grid">
            {images.slice(0, 12).map((img, index) => (
              <div 
                key={index} 
                className="gallery-item"
                onClick={() => setSelectedImage(img)}
              >
                <img src={img} alt={`Project ${index + 1}`} />
                <div className="gallery-overlay">
                  <div className="gallery-info">
                    <h4>Project #{index + 1}</h4>
                    <p>Click to view details</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="documents-section">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Documentation</span>
            <h2>Product Catalogs & Technical Documents</h2>
            <p>Download our comprehensive documentation for detailed product information</p>
          </div>

          <div className="documents-grid">
            {documents.map((doc, index) => (
              <div 
                key={index} 
                className="document-card"
                onClick={() => window.open(doc.file, '_blank')}
              >
                <div className="document-thumbnail">
                  <div className="pdf-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 18H17V16H7V18Z" fill="currentColor"/>
                      <path d="M17 14H7V12H17V14Z" fill="currentColor"/>
                      <path d="M7 10H11V8H7V10Z" fill="currentColor"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V9C21 5.13401 17.866 2 14 2H6ZM6 4H13V9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5C5 4.44772 5.44772 4 6 4ZM15 4.10002C16.6113 4.4271 17.9413 5.52906 18.584 7H15V4.10002Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div className="document-overlay">
                    <span className="view-text">Click to View</span>
                  </div>
                </div>
                <div className="document-info">
                  <h4>{doc.name}</h4>
                  <p>{doc.description}</p>
                  <span className="document-format">PDF Document</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-header-new">
            <span className="section-label">Contact Us</span>
            <h2>Get in Touch with Our Team</h2>
            <p>Reach us directly by phone or email for all inquiries</p>
          </div>

          <div className="contact-grid">
            <div className="contact-compact">
              <div className="contact-compact-card">
                <h3>Direct Contact</h3>
                <div className="contact-compact-links">
                  <a href="mailto:info@worldexinc.ca" className="contact-pill">Email: info@worldexinc.ca</a>
                  <a href="tel:+14389905985" className="contact-pill">Call: +1 (438) 990-5985</a>
                  <a href="tel:+15148040797" className="contact-pill">Call: +1 (514) 804-0797</a>
                </div>
              </div>
              <div className="contact-compact-meta">
                <div className="contact-meta-item">
                  <span>Address</span>
                  <p>1220 rue Bergar H7L 5A2, Laval, Quebec, Canada</p>
                </div>
                <div className="contact-meta-item">
                  <span>Working Hours</span>
                  <p>Mon-Fri: 09:00 - 18:00 | Sat: 09:00 - 14:00</p>
                </div>
              </div>
            </div>
          </div>

          <div className="map-section">
            <h3>Visit Our Location</h3>
            <div className="map-container">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2788.8744686953373!2d-73.73551492351644!3d45.60108607107622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc9216c7e3b3b3b%3A0x8b3b3b3b3b3b3b3b!2s1220%20Rue%20Bergar%2C%20Laval%2C%20QC%20H7L%205A2%2C%20Canada!5e0!3m2!1sen!2sus!4v1707778800000!5m2!1sen!2sus"
                width="100%" 
                height="320" 
                style={{border: 0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Worldexinc Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/logo.png" alt="Worldexinc Logo" className="footer-logo-img" />
              </div>
              <p className="footer-desc">
                With over 15 years of experience, we deliver high-quality sandwich panels 
                to industrial and commercial projects worldwide. Your trusted partner for 
                excellence in construction solutions.
              </p>
            </div>
            <div className="footer-section">
              <h4>Products</h4>
              <ul>
                <li><a href="#products">Sandwich Panels</a></li>
                <li><a href="#products">Wall Panels</a></li>
                <li><a href="#products">Roof Panels</a></li>
                <li><a href="#products">Cold Storage Panels</a></li>
                <li><a href="#products">Fire-Rated Panels</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#gallery">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="#products">Technical Specs</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact Info</h4>
              <ul className="footer-contact">
                <li>
                  <strong>Email:</strong><br />
                  info@worldexinc.ca
                </li>
                <li>
                  <strong>Phone:</strong><br />
                  +1 (438) 990-5985<br />
                  +1 (514) 804-0797
                </li>
                <li>
                  <strong>Address:</strong><br />
                  1220 rue Bergar H7L 5A2<br />
                  Laval, Quebec, Canada
                </li>
                <li>
                  <strong>Follow Us:</strong>
                  <div className="footer-social">
                    <a href="https://www.instagram.com/worldexinc.ca" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Instagram">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61581325739211" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Facebook">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>
              &copy; 2026 Worldexinc. All rights reserved. | <a href="/#/privacy-policy">Privacy Policy</a> | Terms of Service
            </p>
          </div>
        </div>
      </footer>

      {/* Image Modal */}
      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content">
            <img src={selectedImage} alt="Selected" />
            <button className="modal-close" onClick={() => setSelectedImage(null)}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
